import { createRootRoute } from "@tanstack/react-router"

// Augment TanStack's `StaticDataRouteOption` with the metadata used by the
// React route tree and shared application layout.
declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    componentName?: string | null
    menu?: "default" | "organization" | "browser" | "none"
  }
}

// Exists in its own file to break the import cycle between `routes`
// (each route declares `getParentRoute: () => rootRoute`) and `routeTree`
// (which calls `rootRoute.addChildren(ROUTE_TREE)`).
export const rootRoute = createRootRoute()
